import React from 'react';

import {useLocalize} from '../../../../../../libs/shared/core/src/helpers/internationalization/internationalizationContext';
import {Localizer} from '../../../../../../libs/shared/core/src/helpers/internationalization/localizeTypes';
import {defineMessage} from '../../../../../../libs/shared/core/src/helpers/internationalization/message';
import {PopoverCoordinator} from '../../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {ModifiersEnum} from '../../../../../../srcCommon/inboxes/search/searchModifiersHelpers';
import {InboxesSearchLocationsEnum} from '../../../../../models/url/models/inboxesUrlModel';
import {InboxesParameters} from '../../../../../store/panels/inboxes/parameters/inboxesParameters';
import {useStatusDropdownItems} from '../../searchBar/queryBuilder/inboxesSearchQueryBuilderHelpers';
import {SyncDropdownInputCustomIconProps} from '../../searchBar/queryBuilder/inboxesSearchQueryBuilderTypes';
import {trackSearchHintDropdownOpen} from '../../searchTrackingHelpers';
import {SearchHintItemPill} from '../searchHintItemPill';
import {SearchModifierStatusDropdown} from './searchModifierStatusDropdown';

interface SearchModifierStatusProps {
  selectedItems: ReadonlyArray<string>;
  isDisabled: boolean;
  selectedLocation: InboxesSearchLocationsEnum;
  parameters?: InboxesParameters;
  queryHash?: string;
  onClick: (arg: string) => void;
  onClear: () => void;
}

export const SearchModifierStatus = (props: SearchModifierStatusProps) => {
  const {selectedItems, queryHash, isDisabled, selectedLocation, parameters, onClick, onClear} = props;
  const interactionId = 'search-hint-is';

  const localize = useLocalize();
  const {statuses, shouldRenderSeparator} = useStatusDropdownItems({selectedLocation, parameters});

  const validSelectedStatuses = selectedItems.filter((item) =>
    statuses.some((status) => status.inputValue.value === item),
  );
  const isActive = validSelectedStatuses.length > 0;

  return (
    <PopoverCoordinator
      renderButton={(isOpen) => (
        <SearchHintItemPill
          isActive={isActive}
          isDisabled={isDisabled}
          isHovered={isOpen}
          interactionId={interactionId}
        >
          {renderStatusModifierTitle(statuses, validSelectedStatuses, localize)}
        </SearchHintItemPill>
      )}
      onPopoverToggle={(isOpen) => {
        if (isOpen) {
          trackSearchHintDropdownOpen({
            queryHash,
            modifier: ModifiersEnum.IS,
          });
        }
      }}
      renderModal={(popoverProps) => (
        <SearchModifierStatusDropdown
          popoverProps={popoverProps}
          items={statuses}
          selectedItems={validSelectedStatuses}
          onClick={onClick}
          onClear={onClear}
          shouldRenderSeparator={shouldRenderSeparator}
        />
      )}
    />
  );
};

export const renderStatusModifierTitle = (
  statuses: ReadonlyArray<SyncDropdownInputCustomIconProps>,
  selectedValues: ReadonlyArray<string>,
  localize: Localizer,
) => {
  if (selectedValues.length === 0) {
    const localizedStatus = localize(
      defineMessage({
        id: 'search-hint-is',
        message: 'Status',
      }),
    );

    return localizedStatus;
  }
  const localizedIs = localize(
    defineMessage({
      id: 'search-hint-is-prefix',
      message: 'Is',
    }),
  );

  const firstStatus = statuses.find((e) => e.inputValue.value === selectedValues[0]);
  return `${localizedIs} ${firstStatus?.textLabel}${
    selectedValues.length > 1 ? `, +${selectedValues.length - 1}` : ''
  }`;
};
